import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=664407dc&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=ts&"
export * from "./auth.vue?vue&type=script&lang=ts&"
import style0 from "./auth.vue?vue&type=style&index=0&id=664407dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664407dc",
  null
  
)

export default component.exports